export interface IGetItemProps {
  pageNumber: number;
  startPage: number;
  endPage: number;
  itemIndex: number;
  pagesTotal: number;
  pagesList: number[];
}

export const getItemText = ({
  itemIndex,
  pageNumber,
  startPage,
  endPage,
  pagesTotal,
  pagesList,
}: IGetItemProps): string => {
  const isMoreBefore = itemIndex === 1 && startPage > 2;
  const isMoreAfter = itemIndex === pagesList.length - 2 && endPage < pagesTotal - 1;

  return isMoreBefore || isMoreAfter ? '...' : `${pageNumber}`;
};
